import { readable, writable } from "svelte/store";

const lookups = writable(window.lookups);

export default lookups;
